import * as React from 'react'
import { SVGProps } from 'react'

const MasterCardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={62} height={40} {...props}>
    <g data-name="Group 57298">
      <g data-name="Group 55347">
        <g data-name="Rectangle 3289" fill="none" stroke="#d3dade" strokeLinecap="round">
          <rect width={62} height={40} rx={4} stroke="none" />
          <rect x={0.5} y={0.5} width={61} height={39} rx={3.5} />
        </g>
      </g>
      <g data-name="MC Card">
        <path data-name="Rectangle 278" fill="#ff5f00" d="M27.198 12.9h8.3v14.913h-8.3z" />
        <path
          data-name="Path 7816"
          d="M27.725 20.356a9.51 9.51 0 0 1 3.61-7.456 9.485 9.485 0 1 0 0 14.913 9.471 9.471 0 0 1-3.61-7.457Z"
          fill="#eb001b"
        />
        <path
          data-name="Path 7817"
          d="M46.695 20.356a9.475 9.475 0 0 1-15.334 7.457 9.506 9.506 0 0 0 0-14.913 9.475 9.475 0 0 1 15.334 7.456Z"
          fill="#f79e1b"
        />
      </g>
    </g>
  </svg>
)

export default MasterCardIcon
